import { DefaultState } from 'store/reducers/types';

export const READ_COMMENT_REPORT_DATA_REQUEST = 'READ_COMMENT_REPORT_DATA_REQUEST';
export const READ_COMMENT_REPORT_DATA_SUCCESS = 'READ_COMMENT_REPORT_DATA_SUCCESS';
export const READ_COMMENT_REPORT_DATA_FAILURE = 'READ_COMMENT_REPORT_DATA_FAILURE';

export type CommentReportData = {
  associateId: number;
  associateName: string;
  authorName: string;
  category: string;
  commentBody: string;
  date: string;
};

export type CommentReportState = DefaultState & {
  contents?: CommentReportData;
};

interface ReadCommentReportDataRequest {
  type: typeof READ_COMMENT_REPORT_DATA_REQUEST;
};

interface ReadCommentReportDataSuccess {
  type: typeof READ_COMMENT_REPORT_DATA_SUCCESS,
  contents: CommentReportData;
}

interface ReadCommentReportDataFailure {
  type: typeof READ_COMMENT_REPORT_DATA_FAILURE;
}

export type CommentReportActionTypes = ReadCommentReportDataRequest | ReadCommentReportDataSuccess | ReadCommentReportDataFailure;